/* i18n helper (global) */
if(typeof window!=="undefined" && typeof window.TR==="undefined"){window.TR=function(k,v){return (window.GS&&GS.t)?GS.t(k,v):k;};}
var TR=window.TR;
/*! GhostStat Live Online — polls a snapshot every 8s and renders realtime state. */
(function () {
  function TT(k){ return (window.GS&&GS.t)?GS.t(k):k; }
  "use strict";
  /* Answers "is the deployed file the new one?" without a deploy archaeology session. If the
     console does not say 1.0.1, a stale edge copy is being served — purge the CDN. */
  try { (window.GS_BUILD = window.GS_BUILD || {})["live-online"] = "1.1.0"; } catch (e) {}
  /* Links go through the shared builder so Live, Geo, the Visits log and VI cannot disagree about
     spelling (?v= vs ?id= is how the profile link broke). Inline fallback if it is not loaded. */
  var link = (window.GSLink) ? window.GSLink : {
    visitor: function (vid) { return "/visitor-intelligence?id=" + encodeURIComponent(vid); },
    geo: function (o) { return "/geo" + (o && o.country ? "?country=" + encodeURIComponent(o.country) : ""); }
  };

  if (window.__liveWired) return; window.__liveWired = 1;

  var root, timer = null, POLL = 8000, paused = false, win = 300, lastFeedKey = "", SHOWN = 0;
  function q(s) { return root ? root.querySelector('[data-l="' + s + '"]') : null; }
  function qa(s) { return root ? Array.prototype.slice.call(root.querySelectorAll(s)) : []; }
  function esc(s) { return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); }
  function siteParam() { return "site=" + encodeURIComponent((window.GS && GS.site) || ""); }
  function ready(fn) { var done = false; function go() { if (done) return; done = true; fn(); } document.addEventListener("gs:ready", go, { once: true }); var n = 0, t = setInterval(function () { if (window.GS && GS.api && GS.site) { clearInterval(t); go(); } else if (++n > 200) clearInterval(t); }, 30); if (window.GS && GS.api && GS.site) go(); }

  function dash(v) { return v == null || v === "" ? "\u2014" : esc(v); }
  function secs(s) { s = +s || 0; if (s < 60) return s + "s"; var m = Math.floor(s / 60), r = s % 60; return m + "m" + (r ? " " + r + "s" : ""); }
  function ago(ts) { var d = ts ? new Date(String(ts).replace(" ", "T") + "Z") : null; if (!d) return ""; var s = Math.max(0, (Date.now() - d.getTime()) / 1000); if (s < 60) return Math.round(s) + "s ago"; if (s < 3600) return Math.round(s / 60) + "m ago"; return Math.round(s / 3600) + "h ago"; }
  function winLabel(w) { return w >= 60 ? (w / 60) + " min" : w + "s"; }

  function render(d) {
    q("c-online").textContent = (d.online || 0).toLocaleString();
    q("c-sessions").textContent = (d.active_sessions || 0).toLocaleString() + " active session" + (d.active_sessions === 1 ? "" : "s");
    q("c-pv").textContent = (d.pageviews || 0).toLocaleString();
    q("c-ev").textContent = (d.events || 0).toLocaleString();
    var wl = "last " + winLabel(d.window || win);
    q("c-win1").textContent = wl; q("c-win2").textContent = wl;

    // sparkline
    var s = d.series || [], max = s.reduce(function (m, x) { return Math.max(m, x.n); }, 0) || 1;
    q("spark").innerHTML = s.map(function (x) { var h = Math.round(x.n / max * 100); return '<i class="' + (x.n === max && max > 0 ? "hot" : "") + '" style="height:' + Math.max(3, h) + '%" title="' + x.t + ": " + x.n + '"></i>'; }).join("");

    // active visitors
    var vs = d.visitors || [];
    q("v-count").textContent = vs.length ? vs.length.toLocaleString() + " online" : "";
    var head = '<thead><tr><th>'+TT('lo.js.current_page')+'</th><th>'+TT('lo.js.on_page')+'</th><th>'+TR('liveon.g.state')+'</th><th>'+TR('liveon.g.device')+'</th><th>'+TR('liveon.g.browser')+'</th><th>'+TR('liveon.g.country')+'</th><th>'+TR('liveon.g.source')+'</th><th></th></tr></thead>';
    function liveRow(v) {
      // Everything on this page exists to answer "who is that?", so every row is a door into the
      // profile. Country goes to Geo at whatever depth we resolved.
      var who = v.vid
        ? '<a class="l-open" href="' + esc(link.visitor(v.vid)) + '" title="Open visitor ' + esc(v.short || "") + ' in Visitor Intelligence">' +
          '<i class="bi bi-person-badge"></i></a>'
        : "";
      var country = v.country
        ? '<a class="l-geo" href="' + esc(link.geo({ country: v.country })) + '" title="'+TT('lo.tip_geo')+'">' + dash(v.country) + '</a>'
        : dash(v.country);
      return '<tr' + (v.vid ? ' data-vid="' + esc(v.vid) + '"' : "") + '><td class="page" title="' + dash(v.page) + '">' + dash(v.page) + '</td><td class="num">' + secs(v.on_page) +
        '</td><td><span class="state ' + v.state + '"><i></i>' + (v.state === "active" ? "Active" : "Idle") + '</span></td><td>' + dash(v.device) +
        '</td><td>' + dash(v.browser) + '</td><td>' + country + '</td><td>' + dash(v.source) + '</td><td class="l-act">' + who + '</td></tr>';
    }
    // The list refreshes every few seconds. Remounting the pager at page 1 each time would yank
    // rows away mid-read, so SHOWN records how far it was expanded and startAt restores it.
    q("tbl").innerHTML = head + "<tbody></tbody>";
    var ltb = q("tbl").querySelector("tbody");
    if (window.GSMore) {
      var wasShown = SHOWN;   // how far the reader had expanded before this refresh
      SHOWN = 0;              // recount for this mount, otherwise it would grow every poll
      GSMore.mount({ container: ltb, table: true, colspan: 8, items: vs, pageSize: 20, startAt: wasShown,
                     emptyText: TR('liveon.f2.no_visitors_online_right_now'), render: liveRow,
                     onPage: function (added) { SHOWN += added.length; } });
    } else ltb.innerHTML = vs.length ? vs.map(liveRow).join("") : '<tr><td colspan="8" class="l-empty">'+TR('liveon.f2.no_visitors_online_right_now')+'</td></tr>';

    // feed
    var feed = d.feed || [], fkey = feed.length ? (feed[0].ts + feed[0].label) : "";
    q("feed").innerHTML = feed.length ? feed.map(function (f, i) {
      return '<div class="frow ' + (fkey !== lastFeedKey && i === 0 ? "fnew" : "") + '"><span class="fdot ' + (f.kind === "event" ? "ev" : "pv") + '"></span>' +
        '<span class="flabel">' + dash(f.label) + '</span><span class="fmeta">' + dash(f.device) + (f.country ? " \u00b7 " + esc(f.country) : "") + " \u00b7 " + ago(f.ts) + '</span></div>';
    }).join("") : '<div class="l-empty">'+TR('liveon.no_activity_in_the_window')+'</div>';
    lastFeedKey = fkey;

    // breakdowns
    function bars(rows) { var mx = rows.reduce(function (m, x) { return Math.max(m, x.n); }, 0) || 1; return rows.length ? rows.map(function (x) { return '<div class="bbar"><div class="lbl">' + dash(x.k) + '</div><div class="trk"><i style="width:' + Math.round(x.n / mx * 100) + '%"></i></div><div class="n">' + x.n + '</div></div>'; }).join("") : '<div class="gs-muted small">\u2014</div>'; }
    q("dev").innerHTML = bars(d.devices || []);
    q("ctry").innerHTML = bars(d.countries || []);

    var b = q("banner");
    if (b) { if (!d.stitch) { b.hidden = false; b.innerHTML = '<i class="bi bi-info-circle me-1"></i>Visitor stitching is off, so returning visitors aren\u2019t recognised across days here. Live counts still work. Enable stitching from Cohort Analysis or Visitor Intelligence for cross-day identity.'; } else b.hidden = true; }
  }

  function poll() {
    GS.api("/plugin/live-online/snapshot?" + siteParam() + "&win=" + win).then(function (r) { if (r.ok && r.data) render(r.data); });
  }
  function start() { stop(); if (!paused) { poll(); timer = setInterval(function () { if (!paused && document.visibilityState !== "hidden") poll(); }, POLL); } }
  function stop() { if (timer) { clearInterval(timer); timer = null; } }

  function init() {
    root = document.querySelector('[data-l="root"]'); if (!root) return;

    // window menu
    var wb = q("winBtn"), wm = q("winMenu");
    if (wb && wm) {
      wb.addEventListener("click", function (e) { if (wm.contains(e.target) && e.target !== wb) return; e.stopPropagation(); wm.classList.toggle("open"); });
      document.addEventListener("click", function () { wm.classList.remove("open"); });
      wm.querySelectorAll(".mi").forEach(function (mi) {
        mi.addEventListener("click", function () {
          win = +mi.getAttribute("data-win"); wm.classList.remove("open");
          wm.querySelectorAll(".mi").forEach(function (x) { x.classList.remove("sel"); }); mi.classList.add("sel");
          q("winLabel").textContent = winLabel(win);
          GS.api("/plugin/live-online/save-settings?" + siteParam(), { method: "POST", body: JSON.stringify({ site: (window.GS && GS.site) || "", window: win }) });
          poll();
        });
      });
    }
    // pause
    var pb = q("pause");
    if (pb) pb.addEventListener("click", function () {
      paused = !paused;
      pb.innerHTML = paused ? '<i class="bi bi-play-fill"></i> Resume' : '<i class="bi bi-pause-fill"></i> Pause';
      q("dot").classList.toggle("paused", paused);
      if (paused) stop(); else start();
    });
    document.addEventListener("visibilitychange", function () { if (document.visibilityState === "visible" && !paused) poll(); });

    start();
  }
  ready(init);
})();
